import * as constants from "../constants/CONSTANT";
import authApi from "./authApi";

const JajotApi = {
  // ************************************** IBS-JAJOT-APIS ************************************************

  // *********************************Access Salesforce Contact Record according to email id ****************************
  async getContactRecordByEmail(email) {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/salesforce/useremail/",
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();
    if (result) {
      return result;
    }
    return null;
  },

  // ************************** Access All the holiday dates *****************************
  async getHolidays() {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/salesforce/holidays/",
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();
    if (result) {
      return result;
    }
    return null;
  },

  //************************ */ Access All the project list *************************
  async getProjectRecords() {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/salesforce/projects",
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();
    if (result) {
      return result;
    }
    return null;
  },

  // ***************************Access All the working hours according to start and end date **************
  async getWorkingHours(data) {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL +
      "/api/salesforce/workinghours/" +
      "?startDate=" +
      data.startDate +
      "&endDate=" +
      data.endDate,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();
    if (result) {
      return result;
    }
    return null;
  },

  // ********************************* Create New timesheet working hour project record ************************
  async createProjectRecords(records) {
    const token = localStorage.getItem("token");

    let response = await fetch(
      constants.API_BASE_URL + "/api/salesforce/workinghours",
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(records),
      }
    );
    return await response.json();
  },
  async sendEmailOTPVerification(request) {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/salesforce/request_otp",
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(request),
      }
    );
    return await response.json();
  },

  // ***********************************************************

  async getTimesheetRecordsMonth(data) {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL +
      "/api/salesforce/timesheetmonthdata/" +
      "?startDate=" +
      data.startDate +
      "&endDate=" +
      data.endDate,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();
    if (result) {
      return result;
    }
    return null;
  },
  async otpverification(request) {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/salesforce/otpverify",
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(request),
      }
    );
    return await response.json();
  },

  // ***************** Attendane Section ***********************

  // Created by anirudh (Attendance section Api's)
  async saveAttendance(attendanceDetails, empId) {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/attendance/" + empId,
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(attendanceDetails),
      }
    );
    return await response.json();
  },

  // Retrive the attendance record as the employeeid and only the today's attendance record if it is filled.
  async getAllAttendance(employeeId) {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/attendance/" + employeeId,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
    return await response.json();
  },

  // Retrive the payslip records financial year and list of display on payroll section.
  async getPaySlipRecords() {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/salesforce/pay_slip",
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();

    return result;
  },

  // Retrive the Order Records
  async getOrderRecords() {
    const token = localStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/orders", {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();

    return result;
  },

  async createRecord(objectName, payload) {
    const token = localStorage.getItem("token");

    const endpointMap = {
      Order__c: "orders",
    };

    const endpoint = endpointMap[objectName];
    if (!endpoint) {
      console.error(`No endpoint mapping for ${objectName}`);
      return { success: false, message: `No endpoint for ${objectName}` };
    }

    const url = `${constants.API_BASE_URL}/api/${endpoint}/create`;

    try {
      console.log(`Creating ${objectName} at ${url}`, payload);

      const res = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(payload),
      });

      if (res.status === 401) {
        authApi.logout();
        return { success: false, message: "Unauthorized" };
      }

      const data = await res.json();
      console.log(`${objectName} created successfully:`, data);
      return data;
    } catch (err) {
      console.error(`Error creating ${objectName}:`, err);
      return { success: false, error: err.message };
    }
  },

  async updateRecord(objectName, recordId, payload) {
    const token = localStorage.getItem("token");
    const endpoint = { Order__c: "orders" }[objectName];
    if (!endpoint) return { success: false, message: "No endpoint" };

    try {
      const res = await fetch(
        `${constants.API_BASE_URL}/api/${endpoint}/update/${recordId}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json", Authorization: token },
          body: JSON.stringify(payload),
        }
      );

      if (res.status === 401)
        return { success: false, message: "Unauthorized" };
      return await res.json();
    } catch (err) {
      console.error(err);
      return { success: false, error: err.message };
    }
  },

  async deleteRecord(objectName, recordId) {
    const token = localStorage.getItem("token");
    const endpoint = { Order__c: "orders" }[objectName];
    if (!endpoint) return { success: false, message: "No endpoint" };
    try {
      const res = await fetch(
        `${constants.API_BASE_URL}/api/${endpoint}/delete/${recordId}`,
        {
          method: "DELETE",
          headers: { "Content-Type": "application/json", Authorization: token },
        }
      );

      if (res.status === 401)
        return { success: false, message: "Unauthorized" };
      return await res.json();
    } catch (err) {
      console.error(err);
      return { success: false, error: err.message };
    }
  },

  async getLastOrder() {
    const token = localStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/orders/nextId", {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();

    return result;
  },

  async getLedgerRecords() {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/salesforce/ledgers",
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();

    return result;
  },

  async getStockItemRecords() {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/salesforce/stockitems",
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();

    return result;
  },

  async getStockItemsVoucherEntries(stockItemId) {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL +
      `/api/salesforce/stockitems/voucher-entries/${stockItemId}`,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();
    return result;
  },

  async getVoucherRecords(financialYearId = null) {
    const token = localStorage.getItem("token");
    let url = constants.API_BASE_URL + "/api/salesforce/vouchers";
    if (financialYearId) {
      url += `?financialYearId=${encodeURIComponent(financialYearId)}`;
    }
    const response = await fetch(url, {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();

    return result;
  },

  async getFinancialYears() {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/salesforce/financial-years",
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();

    return result;
  },

  async createTallyRequest(payload) {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/tallyReq/create",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(payload),
      }
    );

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();

    return result;
  },

  async getTallyRequestStatus(requestId) {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + `/api/tallyReq/status/${requestId}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      authApi.logout();
    }

    const result = await response.json();
    return result;
  },

  // Retrive the employees from contact SF object
  async getEmployeeRecords() {
    const token = localStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/employee", {
      method: "GET",
      mode: "cors",
      headers: { "Content-Type": "application/json", Authorization: token },
    });

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();
    if (result) {
      return result;
    }
    return null;
  },

  // Update the employee on the salesforce
  async updateEmployeeRecords(data) {
    const token = localStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/employee", {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(data),
    });
    return await response.json();
  },

  // Update the user password by change password section
  async updateUserPassword(user) {
    let response = await fetch(
      constants.API_BASE_URL + "/api/auth/updatepassword",
      {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: user.authToken,
        },
        body: JSON.stringify(user),
      }
    );
    return await response.json();
  },

  // Leave DashboardView records
  async getLeavesDashboardRecord() {
    const token = localStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/leaves/counts", {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();
    if (result) {
      return result;
    }
    return null;
  },

  async getAllLeavesRecords(obj) {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL +
      "/api/leaves/apply?startDate=" +
      obj.startDate +
      "&endDate=" +
      obj.endDate,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();
    if (result) {
      return result;
    }
    return null;
  },

  // Retriving all the user for notify team members
  async getAllUsers() {
    const token = localStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/leaves/members", {
      method: "GET",
      mode: "cors",
      headers: { "Content-Type": "application/json", Authorization: token },
    });

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();
    if (result) {
      return result;
    }
    return null;
  },

  async getLeavesTableData() {
    const token = localStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/leaves", {
      method: "GET",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
    });

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();
    if (result) {
      return result;
    }
    return null;
  },

  // Insert leave records
  async createLeavesRecords(records) {
    const token = localStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/leaves/apply", {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(records),
    });
    return await response.json();
  },

  // Insert or Update the employee image in attendance section
  async updateEmployeeProfileImage(data) {
    const token = localStorage.getItem("token");
    let response = await fetch(constants.API_BASE_URL + "/api/employee/image", {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify(data),
    });
    return await response.json();
  },

  // Get attendance image
  async getAttendanceImg() {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/salesforce/attendanceimage",
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
    return await response.json();
  },

  // Get sidebar image for profile
  async getEmployeeImage() {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/employee/image/",
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();
    if (result) {
      return result;
    }
    return null;
  },

  async getPaySlipViewRecord(monthSlab) {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/salesforce/pay_slip_view/" + monthSlab,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );
    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();
    return result;
  },

  async getEmployeeImages() {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/employee/images/",
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();
    if (result) {
      return result;
    }
    return null;
  },

  // Retrive the Pdf for a particular payroll by its ID
  async getPayrollPDF(payrollId) {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL +
      "/api/salesforce/payrollattachement/" +
      payrollId,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();
    if (result) {
      return result;
    }
    return null;
  },

  // Save Target amount
  async saveTargetAchieveAmount(dataToSave, recordId) {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/target/" + recordId,
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(dataToSave),
      }
    );
    if (response.status === 401) {
      authApi.logout();
    }

    const result = await response.json();

    if (result) {
      return result;
    }
    return null;
  },

  async getTotalTargetAmount(record, month, year) {
    let recordId = record?.contactDetails?.Id;
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/target/" + recordId,
      {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({ month, year }),
      }
    );

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();
    if (result) {
      return result;
    }
    return null;
  },

  async getRemainingAndTarget(recordId) {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/target/" + recordId,
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();
    if (result) {
      return result;
    }
    return null;
  },

  async social_login(google_profile, token) {
    const { email, name, picture, sub } = google_profile;
    let response = await fetch(
      constants.API_BASE_URL + "/api/auth/social_login",
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          email: email,
          name: name,
          picture: picture.data ? picture.data.url : picture,
          sub: sub,
          password: token,
        }),
      }
    );

    const result = await response.json();
    if (result.success) {
      localStorage.setItem("token", result.authToken);
    }
    return result;
  },

  async changeLeaveStatusToRevoke(leaveRecord, recordId) {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/leaves/changestatus/" + recordId,
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
        body: JSON.stringify(leaveRecord),
      }
    );

    const result = await response.json();
    if (result) {
      return result;
    }
    return null;
  },

  async getHolidays() {
    const token = localStorage.getItem("token");
    let response = await fetch(
      constants.API_BASE_URL + "/api/salesforce/holidays/",
      {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    );

    if (response.status === 401) {
      authApi.logout();
    }
    const result = await response.json();
    if (result) {
      return result;
    }
    return null;
  },

  /**
   * @AddedBy : MOhmmad Sarfaraz
   * @Date : 21/Nov/2025
   */
  async getTasksRecords(relatedRecordId = null, type = null) {
    try {
      const token = localStorage.getItem("token");
      let url = relatedRecordId
        ? `${constants.API_BASE_URL}/api/tasks/${relatedRecordId}`
        : `${constants.API_BASE_URL}/api/tasks`;

      // Add type filter if specified
      if (type) {
        url += `${relatedRecordId ? '?' : '?'}type=${encodeURIComponent(type)}`;
      }

      let response = await fetch(url,
        {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      if (response.status === 401) {
        authApi.logout();
      }
      const result = await response.json();
      return result || null;

    } catch (error) {
      return error;
    }
  },

  async getTaskById(recordId) {
    try {
      const token = localStorage.getItem("token");
      let url = `${constants.API_BASE_URL}/api/tasks?RecordId=${recordId}`;
      let response = await fetch(url,
        {
          method: "GET",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );
      if (response.status === 401) {
        authApi.logout();
      }
      const result = await response.json();
      return result || null;

    } catch (error) {
      return error;
    }
  },

  /**
   * @AddedBy : MOhmmad Sarfaraz
   * @Date : 21/Nov/2025
   */
  async addNewTask(taskRecord, relatedRecordId = null) {
    try {
      const token = localStorage.getItem("token");
      let url = relatedRecordId
        ? `${constants.API_BASE_URL}/api/tasks/${relatedRecordId}`
        : `${constants.API_BASE_URL}/api/tasks`;
      let response = await fetch(url,
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(taskRecord),
        }
      );

      const result = await response.json();
      if (result) {
        return result;
      }
      return null;
    } catch (error) {
      return error;
    }
  },

  /**
   * @AddedBy : MOhmmad Sarfaraz
   * @Date : 25/Nov/2025
   */
  async updateTaskById(payload, recordId) {
    try {
      const token = localStorage.getItem("token");
      let url = `${constants.API_BASE_URL}/api/tasks/${recordId}`;
      let response = await fetch(url,
        {
          method: "PUT",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(payload),
        }
      );

      const result = await response.json();
      if (result) {
        return result;
      }
      return null;
    } catch (error) {
      return error;
    }
  },

  /**
   * @AddedBy : MOhmmad Sarfaraz
   * @Date : 25/Nov/2025
   */
  async deleteTaskBy(recordId) {
    try {
      const token = localStorage.getItem("token");
      let url = `${constants.API_BASE_URL}/api/tasks/${recordId}`;
      let response = await fetch(url,
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      const result = await response.json();
      if (result) {
        return result;
      }
      return null;
    } catch (error) {
      return error;
    }
  },
  async getRecordById(id, linkTo) {
    try {
      const token = localStorage.getItem("token");
      let url = `${constants.API_BASE_URL}/api/salesforce/singleRecord/`;
      let response = await fetch(url,
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({ recordId: id, type: linkTo }),
        }
      );
      if (response.status === 401) {
        authApi.logout();
      }
      const result = await response.json();
      if (result) {
        return result;
      }
      return null;
    } catch (error) {
      return error;
    }
  },

  async getNotificationsList(contactId) {
    try {
      const token = localStorage.getItem("token");
      const url = contactId
        ? `${constants.API_BASE_URL}/api/notificationDevice/${encodeURIComponent(contactId)}`
        : `${constants.API_BASE_URL}/api/notificationDevice/`;

      const response = await fetch(url, {
        method: "GET",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        },
      });

      if (response.status === 401) {
        authApi.logout();
        return [];
      }

      const result = await response.json();
      return result || [];
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async createNotifications(payload) {
    try {
      const token = localStorage.getItem("token");
      let response = await fetch(
        constants.API_BASE_URL + "/api/notificationDevice/",
        {
          method: "POST",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(payload),
        }
      );
      const result = await response.json();
      return result || [];
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async updateNotification(Id, body) {
    try {
      const token = localStorage.getItem("token");
      let response = await fetch(
        constants.API_BASE_URL + `/api/notificationDevice/${Id}`,
        {
          method: "PUT",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify(body),
        }
      );
      const result = await response.json();
      return result || [];
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  async deleteNotification(ids) {
    try {
      // const response = await apiConfig.delete(`/notification/bulk-deletion`, {
      //   data: { ids },
      // });
      const token = localStorage.getItem("token");
      let response = await fetch(
        constants.API_BASE_URL + `/api/notificationDevice/bulk-deletion`,
        {
          method: "DELETE",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
          body: JSON.stringify({ ids }),
        }
      );
      const result = await response.json();
      return result || [];
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
  // Notifications Ended
};

export default JajotApi;
